// DesignationService.ts
import { get, post, put, remove } from './mainApi';
import { IDesignations } from 'src/content/Designation/interface/designation';

const baseUrl = process.env.REACT_APP_LEAVE_MANAGEMENT_SERVICE_V1_ENDPOINT + 'employee/designations';
const traceId = 'TRC382097303';

// Filter should only send known properties: name, pageNo, pageSize
export const getAllDesignations = async (filter: { name: string; pageNo: number; pageSize: number }) => {
  return await post(`${baseUrl}/filter?traceId=${traceId}`, filter);
};

// Create designation – assumes data is already cleaned in caller
export const createDesignation = async (designation: IDesignations) => {
  return await post(`${baseUrl}?traceId=${traceId}`, designation);
};

// Update designation – assumes data is already cleaned in caller
export const updateDesignation = async (designation: IDesignations) => {
  return await put(`${baseUrl}?traceId=${traceId}`, designation);
};
